import React from "react";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import detailCss from "../../css/importaSanzioni/importaSanzioni.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import Papa from "papaparse";
import ImportaSanzioniService from "./ImportaSanzioniService";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import { error } from "jquery";
toast.configure();

export default class ImportaSanzioni extends React.Component{
    constructor(props){
        super(props);
        this.state = {
          loading: true,
          file: {
            file: null,
            value: "",
          },
          extensionError: false,
          headerData: [],
          tableData: [],
          tableDataIssues: 0,
          uploadResult: null,
          showModalFineCheck: false,
          showModalUploadResult: false,
          modalFineCheckData: {
            row: 0,
            issues: [],
          },
          headerMandatory: [
            "localita",
            "lineaMezzo",
            "dataDiEmissione",
            "idStato",
            "idTipologiaSanzione",
            "numeroSanzione",
            "matricolaControllore",
            "lng",
            "lat",
            "isPagatoABordo",
            "isMinorenne",
            "cognome",
            "nome",
            "luogoDiNascita",
            "provinciaDiResidenza",
            "dataDiNascita",
            "capDiResidenza",
            "indirizzoNumeroDiResidenza",
            "comuneDiResidenza",
            "indirizzoDiResidenza",
            "isMinorenneP",
            "cognomeP",
            "nomeP",
            "luogoDiNascitaP",
            "provinciaDiResidenzaP",
            "dataDiNascitaP",
            "capDiResidenzaP",
            "indirizzoNumeroDiResidenzaP",
            "comuneDiResidenzaP",
            "indirizzoDiResidenzaP",
          ],
          headerError: { error: false, message: "", campi: [] },
        };
    }

    componentDidMount(){
        this.impostaSanzioniService = new ImportaSanzioniService();
        this.setState({loading:false})
    }

    showToastSuccess(message) {
        toast.success(message)
    }

    showToastError(message) {
        toast.error(message != null && message != undefined ? message : "Qualcosa è andato storto riprova più tardi")
    }

    showToastWarning(message) {
        toast.warning(message)
    }

    resetTableData() {
        this.setState({
            headerData: [],
            tableData: [],
            tableDataIssues: 0
        })
    }

    resetAttachment() {
        this.resetTableData();
        this.setState({
            uploadResult: null,
            file: {
                file: null,
                value: ""
            },
            extensionError: false
        });
    }

    attachmentOnChanged = async (event) => {
        const file = event.target.files[0];
        const fileExt = file.name.split(".").pop().toLowerCase();

        if(fileExt === 'csv' || file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') {
            this.setState({
                file: {
                    file: file,
                    value: event.target.value
                },
            });
        } else {
            this.setState({
                extensionError: true
            })
        }
    }

    parseFile() {
        const reader = new FileReader();
 
        // Event listener on reader when the file
        // loads, we parse it and set the data.
        reader.onload = async ({ target }) => {
            var result = target.result;
            while((result.lastIndexOf('\n') == result.length-1) || (result.lastIndexOf('\n') == result.length-2 && result[result.length-1]=='\r')) {
                result = result.substring(0, result.length-1)
            }
            const csv = Papa.parse(result, {
                header: true,
            });
            const parsedData = csv?.data;
            let header = ["row", "status"];
            let columns = csv.meta.fields;


            this.setState({headerError:{error:false,message:"",campi:[]}})

            let campiInErrore = [];

            this.state.headerMandatory.forEach((element) => {
                if(!columns.includes(element)){
                    campiInErrore.push(element);
                }
            })

            if(campiInErrore.length > 0){
                this.setState({headerError:{error:true,message:"Errore, controllare che i seguenti campi siano presenti nell'intestazione:",campi:campiInErrore}})
            }

            if(campiInErrore.length === 0){
                columns.forEach((column) => header.push(column));
                let fileData = [];
                let issues = 0;
                for(var c = 0; c<parsedData.length; c++) {
                    //let row = []
                    let issuesFounds = this.checkRow(parsedData[c]);
                    if(issuesFounds.length > 0) issues++
                    //Object.values(parsedData[c]).forEach((column) => row.push(column))
                    parsedData[c].row = c+1
                    // TODO: OnClick => modalFineCheckData e show modal
                    parsedData[c].issues = issuesFounds
                    parsedData[c].status = <div className="fine-status">
                        {issuesFounds.length > 0 ? <i className="fas fa-times fine-status-error"/> : <i className="fas fa-check fine-status-success"/>}
                    </div>
                    fileData.push(parsedData[c])
                };
    
                this.setState({
                    headerData: header.map((element) => {return {
                        label: element,
                        field: element,
                    }}),
                    tableData: fileData,
                    tableDataIssues: issues
                })
            };

            }
           
        reader.readAsText(this.state.file.file);
    }

    checkNotValid(value, lastCheck) {
        return this.checkIsBlank(value) || !lastCheck();
    }

    checkIsBlank(value) {
        // TODO: Necessary? (value.indexOf(" ") >= 0)
        return (value === null || value === undefined) || value.length == 0;
    }

    checkEqualsIgnoreCase(value, checkValue) {
        return value.toLowerCase() === checkValue.toLowerCase();
    }

    checkRegex(value, regex) {
        return (new RegExp(regex).test(value));
    }

    checkLength(value, length) {
        return value.length > length;
    }

    checkEmissionDate(value) {
        //let splittedValue = value.split(" ")
        if(this.checkRegex(value, "[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}")) {
            var date;
            if(this.checkRegex(value, "[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}")) {
                date = moment(value, "YYYY-MM-DD HH:mm:ss")
            } else {
                date = moment(value, "YYYY-MM-DD HH:mm")
            }
            return date !== null && date !== undefined && date.toDate().getTime() !== NaN && date.isBefore(moment(new Date()))
        }
        return false
    }

    checkDate(value) {
        if(this.checkRegex(value, "[0-9]{4}-[0-9]{2}-[0-9]{2}")) {
            var date = moment(value, "YYYY-MM-DD")
            return date !== null && date !== undefined && date.toDate().getTime() !== NaN && date.isBefore(moment(new Date()))
        }
        return false
    }

    checkRow(rowFields) {
        let issues = [];
        var isMinorenne = false
        if(this.checkNotValid(rowFields.localita, () => this.checkLength(rowFields.localita, 1))) {
            issues.push("Località non presente")
        }
        if(this.checkIsBlank(rowFields.lineaMezzo)) {
            issues.push("Linea mezzo non presente")
        }
        if(this.checkNotValid(rowFields.dataDiEmissione, () => this.checkEmissionDate(rowFields.dataDiEmissione))){
            issues.push("Data emissione non valida o non presente")
        }
        if(this.checkNotValid(rowFields.idStato, () => this.checkRegex(rowFields.idStato, "[0-9]+"))) {
            issues.push("Stato sanzione non valido o non presente");
        }
        if(this.checkNotValid(rowFields.idTipologiaSanzione, () => this.checkRegex(rowFields.idTipologiaSanzione, "[0-9]+"))) {
            issues.push("Tipologia sanzione non valida o non presente");
        }
        if(this.checkNotValid(rowFields.numeroSanzione, () => this.checkLength(rowFields.numeroSanzione, 4))) {
            issues.push("Numero sanzione non valido o non presente");
        }
        if(this.checkNotValid(rowFields.matricolaControllore, () => this.checkLength(rowFields.matricolaControllore, 2))) {
            issues.push("Matricola Controllore non valida o non presente");
        }
        try {
            parseFloat(rowFields.lng);
        }catch (Exception){
            issues.push("Errore sul parse LNG");
        }
        try {
            parseFloat(rowFields.lat);
        }catch (Exception){
            issues.push("Errore sul parse LAT");
        }
        if (this.checkNotValid(rowFields.isPagatoABordo, () => this.checkRegex(rowFields.isPagatoABordo, "[0-9]+"))) {
            issues.push("Is pagato a bordo non valido o non presente");
        }
        if(rowFields.isPagatoABordo !== "0" && rowFields.idStato !== "7") {
            issues.push("Stato sanzione diverso da 7 (pagata) con sanzione pagata a bordo")
        }
        /**
         * nome, cognome, data di nascita, luogo nascita, comune, indirizzo, numero, cap e provincia
         */
        /*try {
            sanzionato.setDataRilascioDocumento(StringUtils.isNotBlank(campi[14]) ? new Date(Long.parseLong(campi[14])) : null);
        }catch (Exception ee){
            throw new RuntimeException("data rilascio documento non valido");
        }*/
        if(this.checkNotValid(rowFields.isMinorenne, () => this.checkRegex(rowFields.isMinorenne, "[0-1]"))) {
            issues.push("is minorenne sanzionato non valido o non presente");
        } else {
            isMinorenne = parseInt(rowFields.isMinorenne) !== 0;
        }
        if(this.checkIsBlank(rowFields.cognome)) {
            issues.push("cognome sanzionato non presente");
        }
        if(this.checkNotValid(rowFields.sesso, () => rowFields.sesso === "F" || rowFields.sesso === "M")) {
            issues.push("sesso sanzionato non valido o non presente");
        }
        if(this.checkIsBlank(rowFields.nome)) {
            issues.push("nome sanzionato non presente");
        }
        if(this.checkIsBlank(rowFields.luogoDiNascita)) {
            issues.push("Luogo di nascita sanzionato non presente");
        }
        /*if(this.checkIsBlank(rowFields.provinciaDiResidenza)) {
            issues.push("provincia residenza sanzionato non presente");
        }*/
        if(this.checkNotValid(rowFields.dataDiNascita, () => this.checkDate(rowFields.dataDiNascita))) {
            issues.push("data di nascita sanzionato non presente o non valida");
        } else {
            var date = moment(rowFields.dataDiNascita, "YYYY-MM-DD")
            var isMinorenneCheck = moment(rowFields.dataDiEmissione, "YYYY-MM-DD").isBefore(date.add(18, "years"))
            if(!isMinorenneCheck && isMinorenne || isMinorenneCheck && !isMinorenne) {
                issues.push("Data di nascita incongruente con campo is minorenne");
            }
        }
        /*if(this.checkNotValid(rowFields.capDiResidenza, () => this.checkRegex(rowFields.capDiResidenza, "[0-9]+"))) {
            issues.push("cap sanzionato non presente o non valida");
        }*/
        /*if(this.checkIsBlank(rowFields.indirizzoNumeroDiResidenza)) {
            issues.push("numero residenza sanzionato non presente");
        }*/
        if(this.checkIsBlank(rowFields.comuneDiResidenza)) {
            issues.push("comune residenza sanzionato non presente");
        }
        if(this.checkIsBlank(rowFields.indirizzoDiResidenza)) {
            issues.push("indirizzo residenza sanzionato non presente");
        }

        // console.log("Is minorenne " + isMinorenne);

        /**
         * se il sanzionato è minorenne i seguenti campi sono obbligatori nome, cognome, data di nascita,
         * luogo nascita, comune, indirizzo, numero, cap e provincia
         */
        /*if(isMinorenne) {
            if(this.checkNotValid(rowFields.isMinorenneP, () => this.checkEqualsIgnoreCase(rowFields.isMinorenneP, "0"))) {
                issues.push("is minorenne patria potesta non valido o non presente");
            }
            if(this.checkIsBlank(rowFields.cognomeP)) {
                issues.push("cognome patria potesta non presente");
            }
            if(this.checkIsBlank(rowFields.nomeP)) {
                issues.push("nome patria potesta non presente");
            }
            if(this.checkIsBlank(rowFields.luogoDiNascitaP)) {
                issues.push("Luogo di nascita patria potesta non presente");
            }
            if(this.checkIsBlank(rowFields.provinciaDiResidenzaP)) {
                issues.push("provincia residenza patria potesta non presente");
            }
            if(this.checkNotValid(rowFields.dataDiNascitaP, () => this.checkDate(rowFields.dataDiNascitaP))) {
                issues.push("data di nascita patria potesta non presente o non valida");
            }
            if(this.checkNotValid(rowFields.capDiResidenzaP, () => this.checkRegex(rowFields.capDiResidenzaP, "[0-9]+"))) {
                issues.push("cap patria potesta non presente o non valida");
            }
            if(this.checkIsBlank(rowFields.indirizzoNumeroDiResidenzaP)) {
                issues.push("numero residenza patria potesta non presente");
            }
            if(this.checkIsBlank(rowFields.comuneDiResidenzaP)) {
                issues.push("comune residenza patria potesta non presente");
            }
            if(this.checkIsBlank(rowFields.indirizzoDiResidenzaP)) {
                issues.push("indirizzo residenza patria potesta non presente");
            }
        }*/
        return issues;
    }

    getTableData() {
        for(var c in this.state.tableData) {
            let data = this.state.tableData[c]
            this.state.tableData[c].clickEvent = () => {
                this.setState({
                    modalFineCheckData: data,
                    showModalFineCheck: true
                })
            }
        }
        return {
            columns: this.state.headerData.slice(0, 9),
            rows: this.state.tableData
        };
    }

    uploadFile() {
        this.impostaSanzioniService.uploadFile(this.state.file.file, this.onUploadResult.bind(this), this.showToastError.bind(this))
    }

    onUploadResult(result) {
        result.fileName = this.state.file.file.name;
        
        if(result.sanzioniSalvate === result.numeroSanzioni) {
            this.showToastSuccess("Sanzioni importate correttamente");
        } else if(result.sanzioniSalvate === 0) {
            this.showToastError("Errore importazione sanzioni");
        } else {
            this.showToastWarning("Sanzioni importate " + result.sanzioniSalvate + " su " + result.numeroSanzioni);
        }

        this.resetTableData();
        this.setState({
            uploadResult: result,
            file: {
                file: null,
                value: ""
            },
            extensionError: false
        });
    }

    showModalFineCheck(){
        return(
          <Modal size="xl" show={this.state.showModalFineCheck} dialogClassName="modal-fine-check">
            <Modal.Header><h1>{"Riga n° " + this.state.modalFineCheckData.row}</h1></Modal.Header>
            <Modal.Body>
                <strong>Problemi rilevati:</strong>
                <br/>
                {
                    this.state.modalFineCheckData.issues.length > 0 ?
                    <p className="text-danger">
                        Sono stati rilevati i seguenti problemi:
                        <ul>
                            {
                                this.state.modalFineCheckData.issues.map((issue) => <li>{issue}</li>)
                            }
                        </ul>
                    </p> :
                    <p className="text-success">
                        Nessun problema rilevato
                    </p>
                }
                <strong>Dettaglio sanzione:</strong>
                <br/>
                <CDBDataTable
                    sortable={false}
                    responsiveSm={true}
                    responsiveMd={true}
                    responsiveLg={true}
                    entriesLabel={""}
                    paging={false}
                    searching={false}
                    striped
                    bordered
                    hover
                    checkbox
                    data={{
                        columns: this.state.headerData,
                        rows: [this.state.modalFineCheckData]
                    }}
                    materialSearch
                />
            </Modal.Body>
            <Modal.Footer>
              <Button
              onClick={()=>{
                this.setState({
                    modalFineCheckData: {
                        row: 0,
                        issues: []
                    },
                    showModalFineCheck: false
                })
              }}
              >Chiudi</Button>
            </Modal.Footer>
          </Modal>
        )
    }

    showModalUploadResult(){
        return(
          <Modal size="xl" show={this.state.showModalUploadResult}>
            <Modal.Header><h1>Problemi rilevati:</h1></Modal.Header>
            <Modal.Body>
                Sono stati rilevati i seguenti problemi:
                {
                    <ul>
                        {
                            this.state.uploadResult !== null && this.state.uploadResult !== undefined ? Object.keys(this.state.uploadResult.errori).map((key) => <li>{"Riga " + key + ": " + this.state.uploadResult.errori[key]}</li>) : null
                        }
                    </ul>
                }
            </Modal.Body>
            <Modal.Footer>
              <Button
              onClick={()=>{
                this.setState({
                    showModalUploadResult: false
                })
              }}
              >Chiudi</Button>
            </Modal.Footer>
          </Modal>
        )
    }

    isFileEmpty() {
        return this.state.file.file === null || this.state.file.file === undefined;
    }

    render(){
        return this.state.loading
        ? <LoadSpinner/>
        : (
            <div id="wrapper">
                <Menucustom/>
                <div className="container-fluid">
                    <br />
                    <br />
                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                        <h1 className="h1 mb-2 text-gray-800">
                        Gestione Sanzioni<br></br>
                        <small
                            style={{ fontSize: "14px" }}
                            className="mb-2 text-gray-800"
                        >Sanzioni&#8594;  Importa Sanzioni
                        </small>
                        </h1>
                        </div>
                    <div>
                    <CDBContainer>
                        <CDBCard border>
                            <div className="container p-3">
                                <div className="row">
                                    <div className="import-control-div">
                                        <input
                                            className="form-control"
                                            type="file"
                                            accept=".csv"
                                            //disabled={this.state.attachments.length >= 3}
                                            value={this.state.file.value}
                                            onChange={this.attachmentOnChanged.bind(this)}
                                            onClick={this.resetAttachment.bind(this)}
                                        />
                                        <button disabled={this.isFileEmpty()} className="btn btn-warning separate-right" onClick={()=>this.parseFile()}><i className="fas fa-tasks"/>Valida</button>
                                        <button disabled={this.isFileEmpty() || (this.state.tableData.length === 0 || this.state.tableDataIssues > 0)} className="btn btn-warning" onClick={()=>this.uploadFile()}><i className="fas fa-file-upload"/>Importa</button>
                                    </div>
                                    <small>
                                        Formati accettati: csv.
                                    </small>
                                    {this.state.extensionError 
                                    ? (
                                        <small className="text-danger">
                                            File non valido
                                        </small>
                                    )
                                    :this.state.headerError.error
                                    ? (
                                        <small className="text-danger">
                                            {this.state.headerError.message}
                                            {this.state.headerError.campi.length > 0 &&
                                            <ul>
                                                {this.state.headerError.campi.map((campo,index) => {
                                                    return(<li key={index+"EH"}>{campo}</li>)
                                                })}
                                            </ul>}
                                        </small>
                                    )
                                    :(
                                        ""
                                    )}
                                </div>
                            </div>
                            {/*((this.state.headerData !== null && this.state.headerData !== undefined) && (this.state.tableData !== null && this.state.tableData !== undefined)) ? <table className="import-table">
                                <tr>
                                    {this.state.headerData.map((column) => <th>{column}</th>)}
                                </tr>
                                {this.state.tableData.map((row, index) => {
                                    return <tr>
                                        <td>{index+1}</td>
                                        <td>{
                                            this.state.tableDataIssues.length > 0 ? <i className="fas fa-times"/> : <i className="fas fa-check"/>
                                        }</td>
                                        {
                                            row.map((column) => <td>{column}</td>)
                                        }
                                    </tr>
                                })}
                            </table> : null*/}
                            <CDBCardBody>
                                {(this.state.uploadResult !== null && this.state.uploadResult !== undefined) ?
                                    <>
                                        <h4>{"Esito caricamento file " + this.state.uploadResult.fileName}</h4>
                                        <small className="text-success">
                                            {"Sono state importate " + this.state.uploadResult.sanzioniSalvate + " sanzioni su " + this.state.uploadResult.numeroSanzioni + " sanzioni totali."}
                                        </small>
                                        <br/>
                                        {(this.state.uploadResult.sanzioniFallite > 0) ?
                                            <>        
                                                <small className="text-danger">
                                                    {"Non è stato possibile importare " + this.state.uploadResult.sanzioniFallite + " sanzioni su " + this.state.uploadResult.numeroSanzioni + " sanzioni totali."}
                                                </small>
                                                {
                                                    (this.state.uploadResult.errori !== null && this.state.uploadResult.errori !== undefined && Object.keys(this.state.uploadResult.errori).length > 0) ?
                                                    <>
                                                        <br/>
                                                        <br/>
                                                        <button className="btn btn-warning" onClick={()=>this.setState({showModalUploadResult: true})}>Dettagli</button>
                                                    </> :
                                                    null
                                                }
                                            </> :
                                            <small className="text-success">
                                                Nessun problema rilevato.
                                            </small>
                                        }
                                        <br/>
                                    </> :
                                    null
                                }
                                {(this.state.headerData.length > 0) && (this.state.tableData.length > 0) ?
                                    <>
                                        {(this.state.uploadResult !== null && this.state.uploadResult !== undefined) ? <br/> : null}
                                        <h4>Anteprima file</h4>
                                        {this.state.tableDataIssues > 0 ?
                                            <small className="text-danger">
                                                {"Rilevati problemi in " + this.state.tableDataIssues + " sanzioni su " + this.state.tableData.length + " sanzioni totali"}
                                            </small> :
                                            <small className="text-success">
                                                {"Nessun problema rilevato su " + this.state.tableData.length + " sanzioni totali"}
                                            </small>
                                        }
                                        <CDBDataTable
                                            sortable={false}
                                            responsiveSm={true}
                                            responsiveMd={true}
                                            responsiveLg={true}
                                            pagesAmount={3}
                                            entriesLabel={""}
                                            infoLabel={["Mostra da", "a", "di", "sanzioni totali"]}
                                            paginationLabel={["<-", "->"]}
                                            striped
                                            bordered
                                            hover
                                            checkbox
                                            data={this.getTableData()}
                                            materialSearch
                                        />
                                    </> :
                                    null
                                }
                            </CDBCardBody>
                        </CDBCard>
                        </CDBContainer>
                    </div>
                    {this.showModalFineCheck()}
                    {this.showModalUploadResult()}
                </div>
            </div>
        )
    }
}